'use client';

import { tranText } from './tranText';
import getLocal from '@/app/utils/getLocal';

export default function CreditsLine({ creditsData = {} }: any) {
    const { locale } = getLocal();
    const textObj = tranText[locale] || tranText['us'];

    return (
        <div className="eco-redeem-rewards-more-box-credits">
            <span>{textObj.credits_1}</span>
            <span>{creditsData.points}</span>
            <span>{textObj.credits_2}</span>
        </div>
    );
}
